import React, { useEffect, useRef, useState, memo } from 'react';
import ReelsLeftMemo from './ReelsLeft';
import ReelsRight from './ReelsRight';
import '../Styles/Reels/VideoCard.css';
import { BsHeartFill, BsPause } from 'react-icons/bs';
import { useLocation } from 'react-router-dom';
import axiosVendorInstance from '../axiosVendorInstance';
import axiosUserInstance from '../axiosUserInstance';
import { useMute } from '../MuteContext';
import { Menu, MenuItem } from '@mui/material';
import { useCart } from '../CartProvider';
import MoreVertIcon from '@mui/icons-material/MoreVert';
let currentlyPlayingVideo = null;

function VideoCard(props) {
    const {
        url,
        id,
        reelsId,
        vendorID,
        AccountID,
        video,
        profilePic,
        userName,
        restaurantName,
        starPic,
        rating,
        distance,
        description,
        order,
        likes,
        comments,
        shares,
        setVideoRef,
        handleMute,
        globalMuteIcon,
        toggleMuteIcon,
        restaurant,
        coordinate,
        saveFlag,
        likeFlag,
        firstName,
        lastName,
        itemName,
        vendorDescription,
        vendorAddress,
        followFlag,
        filter,
        user_Rating_count,
        handleGlobalMuteChange,
        onEditPost,      
        onDeletePost,
    } = props;

    const videoRef = useRef(null);

    const [like, setLike] = useState(false);
    const [isPaused, setIsPaused] = useState(true);
    const [isHeartActive, setIsHeartActive] = useState(false);

    const [likesCount, setLikesCount] = useState(likes);
    const [isLike, setIsLike] = useState(false);
    const [commentsCount, setCommentsCount] = useState(comments);
    const [commentsList, setCommentsList] = useState([]);
    const [animateModal, setAnimateModal] = useState(false);
    const [closing, setClosing] = useState(false);
    const location = useLocation();
    const { isMuted } = useMute();
    const {userData} = useCart();
    const [anchorEl, setAnchorEl] = useState(null);
    const isProfilePage = location.pathname.includes('/profile');

    const handleMenuClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    
    const handleEdit = () => {
        onEditPost?.();
        handleMenuClose();
    };
    
    const handleDelete = () => {
        onDeletePost?.();
        handleMenuClose();
    };

    const isSearchPage = location.pathname === '/search';
    const [isPlaying, setIsPlaying] = useState(
        window.innerWidth <= 800 || location.pathname === '/Dashboard' || location.pathname === '/reels'
    );

    const getLikes = async () => {
        try {
            const response = await axiosUserInstance.get(`/customers/likes/${id}`, {
                skipAuth: true,
            });

            if (response?.statusText == 'OK') {
                setLikesCount(response?.data?.likeCount);
            } else {
                return;
            }
        } catch (error) {
            console.error('Error from all like count', error);
        }
    };

    useEffect(() => {
        getLikes();
    }, [id, likesCount]);

    useEffect(() => {
        setIsLike(likeFlag === true || likeFlag === 'true');  
    }, [likeFlag]);

    const getComments = async () => {
        await axiosVendorInstance
            .get(`/comments/post/${id}`, { skipAuth: true })
            .then((response) => {
                setCommentsList(response?.data?.comments);
                setCommentsCount(response?.data?.commentCount);
            })
            .catch((error) => {
                console.error('There was an error fetching the comments!', error);
            });
        setClosing(false);
        setTimeout(() => {
            setAnimateModal(true);
        }, 100);
    };

    useEffect(() => {
        getComments();
    }, [id, commentsCount]);

    const isVideoFile = (url) => {
        const videoExtensions = ['mp4', 'mov', 'webm', 'avi'];
        const extension = url.split('.').pop().toLowerCase();
        return videoExtensions.includes(extension);
    };

    const handleDoubleClick = () => {
        setLike((prevLike) => !prevLike);
        setIsHeartActive(true);
        setTimeout(() => {
            setIsHeartActive(false);
        }, 1000);
    };

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handlePlaybackChange = () => {
            setIsPaused(video.paused);
        };
        video.addEventListener('play', handlePlaybackChange);
        video.addEventListener('pause', handlePlaybackChange);

        return () => {
            video.removeEventListener('play', handlePlaybackChange);
            video.removeEventListener('pause', handlePlaybackChange);
        };
    }, [videoRef.current]);

    const handlePause = () => {
        const video = videoRef.current;
        if (!video) return;

        if (video.paused) {
            playVideo();
        } else {
            video.pause();
            setIsPaused(true);
        }
    };

    const playVideo = () => {
        const video = videoRef.current;
        if (!video || !video.paused || !video.src) return;

        if (currentlyPlayingVideo && currentlyPlayingVideo !== video) {
            currentlyPlayingVideo.pause();
            currentlyPlayingVideo.currentTime = 0;
        }

        currentlyPlayingVideo = video;
        video
            .play()
            .catch((error) => console.error('Play request interrupted:', error));
        setIsPaused(false);
    };

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;
    
        const handlePlay = () => {
            if (currentlyPlayingVideo && currentlyPlayingVideo !== video) {
                currentlyPlayingVideo.pause();
                currentlyPlayingVideo.currentTime = 0;
            }
    
            currentlyPlayingVideo = video;
    
            const globalMuted = localStorage.getItem('isMuted') === 'true';
    
            video.muted = globalMuted;
            video.play().catch((err) => console.error('Play error:', err));
            setIsPaused(false);
        };
    
        const handlePause = () => {
            video.pause();
            setIsPaused(true);
            video.muted = true;
        };
    
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    const shouldPlay =
                        window.innerWidth <= 800 ||
                        location.pathname === '/Dashboard' ||
                        location.pathname === '/reels';
                    setIsPlaying(shouldPlay);
    
                    if (shouldPlay && video.src) {
                        handlePlay();
                    }
                } else {
                    handlePause();
                }
            },
            {
                threshold: 0.5, // You can tweak this based on visibility preference
            }
        );
    
        observer.observe(video);
    
        return () => {
            observer.unobserve(video);
        };
    }, [location.pathname]);
 
     
    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;
    
        const isFirstVideo = props.index === 0;
        const shouldAutoplay =
            isFirstVideo &&
            isVideoFile(url) &&
            (
                window.innerWidth <= 800 ||
                location.pathname === '/Dashboard' ||
                location.pathname === '/reels'
            );
    
        if (shouldAutoplay) {
            const tryAutoplayWithRespectToLocalMute = async () => {
                // Always start muted for autoplay
                video.muted = true;
    
                try {
                    await video.play();
                    setIsPaused(false);
    
                    // Now apply actual mute state from localStorage
                    const globalMuted = localStorage.getItem('isMuted') === 'true';
                    video.muted = globalMuted;
                } catch (err) {
                    console.error('❌ Autoplay error (first video):', err);
                }
            };
    
            // Slight delay gives DOM time to render video element
            setTimeout(() => {
                tryAutoplayWithRespectToLocalMute();
            }, 300);
        }
    }, [url, props.index, location.pathname]);

    const getFilterClass = (filter) => {
        switch (filter) {
        case 'brightness':
            return 'brightness';
        case 'contrast':
            return 'contrast';
        case 'saturation':
            return 'saturation';
        case 'hue':
            return 'hue';
        case 'blur':
            return 'blur';
        case 'sepia':
            return 'sepia';
        case 'grayscale':
            return 'grayscale';
        case 'invert':
            return 'invert';
        case 'opacity':
            return 'opacity';
        case 'sharpen':
            return 'sharpen';
        default:
            return 'original';
        }
    };

    return (
        <div className={`video ${isSearchPage ? 'video-important-reels' : ''}`}>

            {isProfilePage && userData?.ID === AccountID && (
                <div className="three-dot-container">
                    <MoreVertIcon
                        onClick={(e) => handleMenuClick(e, id)}
                        fontSize="1.2rem"
                        className="three-dot"
                    />
                    <Menu
                        id="basic-menu"
                        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                    >
                        <MenuItem onClick={handleEdit}>Edit</MenuItem>
                        <MenuItem onClick={handleDelete}>Delete</MenuItem>
                    </Menu>
                </div>
            )}
            {!isVideoFile(url) ? (
                <>
                    <img
                        className={`player ${getFilterClass(filter)}`}
                        src={url}
                        alt="feedimg"
                        onDoubleClick={handleDoubleClick}
                    />
                    <div className="heart-container">
                        <BsHeartFill
                            className={`heart ${isHeartActive ? 'heart-active' : ''}`}
                        />
                    </div>
                </>
            ) : (
                <>
                    
                    <video
                        playsInline
                        className="player"
                        src={url}
                        ref={(ref) => {
                            videoRef.current = ref;
                            if (typeof setVideoRef === 'function') {
                                setVideoRef(ref);
                            }
                        }}
                        muted={isMuted}
                        loop
                        type="video/mp4"
                        autoPlay={isPlaying}
                        onClick={handleGlobalMuteChange}
                    />
                    {isPaused ? (
                        <div className="pause-overlay" onClick={() => handlePause()}>
                            <h2>{isMuted}</h2>
                            <BsPause className="pause-icon" />
                        </div>
                    ) : (
                        <div className="play-overlay" onClick={() => handlePause()}><h2>{isMuted}</h2></div>
                    )}
                </>
            )}

            <div className="bottom-controls">
                <div className="reel-left">
                    <ReelsLeftMemo
                        profilePic={profilePic}
                        userName={userName}
                        restaurantName={restaurantName}
                        AccountID={AccountID}
                        starPic={starPic}
                        rating={rating}
                        distance={distance}
                        description={description}
                        restaurant={restaurant}
                        vendorID={vendorID}
                        coordinate={coordinate}
                        firstName={firstName}
                        lastName={lastName}
                        itemName={itemName}
                        followFlag={followFlag}
                        vendorAddress={vendorAddress}
                        user_Rating_count={user_Rating_count}
                    />
                </div>

                <div className="reel-right">
                    <ReelsRight
                        id={id}
                        vendorID={vendorID}
                        restaurantName={restaurantName}
                        like={like}
                        setLike={setLike}
                        handleMute={handleMute}
                        shares={shares}
                        comments={comments}
                        isLike={isLike}
                        setIsLike={setIsLike}
                        getLikes={getLikes}
                        likesCount={likesCount}
                        commentsCount={commentsCount}
                        setCommentsCount={setCommentsCount}
                        commentsList={commentsList}
                        setCommentsList={setCommentsList}
                        getComments={getComments}
                        order={order}
                        video={video}
                        url={url}
                        isVideoFile={isVideoFile}
                        globalMuteIcon={globalMuteIcon}
                        toggleMuteIcon={toggleMuteIcon}
                        restaurant={restaurant}
                        saveFlag={saveFlag}
                        likeFlag={likeFlag}
                        animateModal={animateModal}
                        setAnimateModal={setAnimateModal}
                        setClosing={setClosing}
                        closing={closing}
                        reelsId={reelsId}
                        vendorAddress={vendorAddress}
                        vendorDistance={distance}
                        rating={rating}
                        vendorDescription={vendorDescription}
                        user_Rating_count={user_Rating_count}
                    />
                </div>
                <div className="video-shadow"></div>
            </div>

            <div className="pause-overlay-all"></div>
        </div>
    );
}

export default memo(VideoCard);
